import React from 'react';
import { Icon } from '@/src/tools/icon';
import css from './css.module.less';
import Button from 'src/components/ClickableContainer';
const CollapseIcon = (props) => {
  const { collapsed, onChange } = props;
  return (
    <Button
      className={css.iconContainer}
      onClick={(e) => {
        onChange(!collapsed);
      }}
      title='Collapse Right Setting Part'>
      {!collapsed ? (
        <Icon type={'iconon'} className={css.icon} />
      ) : (
        <Icon type={'iconoff'} className={css.icon} />
      )}
    </Button>
  );
};
export default CollapseIcon;
